import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import "./index.css";
import { Helmet } from "react-helmet";


const MeetTeam = () => {
  const [teams, setTeams] = useState([]);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  const checkData = () => {
    const app = {};
    getApiData("api/get_leadership_team", app).then((result) => {
      if (result && result["status"] === 200) {
        setTeams(result["data"]);
        const introductionData = result.data[0]; // Ensure data exists
        setMetaTitle(introductionData.meta_title);
        setMetaKeywords(introductionData.meta_keyword);
        setMetaDescription(introductionData.meta_description);
      }
    });
  };

  useEffect(() => {
    checkData();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>
      {/* Main Section */}
      <section>
        <div>
          <h1 className="text-3xl font-semibold text-center mt-8">
            Leadership Team
          </h1>
        </div>
        <div className="max-w-7xl mx-auto lg:pl-[11rem]">
          {/* Loop through Teams */}
          {teams.length > 0 ? (
            teams.map((team, index) => (
              <div className="container mt-12" key={index}>
                <div
                  className={`ceo-grid-2 no-gap ${
                    index % 2 === 0
                      ? "ceo-grid-2-img1"
                      : "cta-grid-main cta-grid-img2 cta-grid-team"
                  }`}
                >
                  {/* Zigzag Layout */}
                  {index % 2 === 0 ? (
                    <>
                      {/* Image on Left */}
                      <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                        <div className="image-wrapper">
                          <img
                            src={team.image}
                            alt={`${team.fname} ${team.lname}`}
                            className="cover-animated-image cover-animated-image1 w-full h-auto rounded-2xl shadow-lg"
                            loading="eager"
                          />
                        </div>
                      </div>
                      <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db578-4b337b90">
                        <div className="p-1rem">
                          <div className="flex-tag left">
                            <div className="bullet-tag"></div>
                          </div>
                          <div className="lg:w-[69%]">
                            <h2>
                              {team.fname}{" "}
                              <span style={{ color: "#4BBA89" }}>
                                {team.lname}:
                              </span>
                            </h2>
                            <h4
                              dangerouslySetInnerHTML={{
                                __html: team.position,
                              }}
                            ></h4>
                            <p
                              className="subhead mt-5 text-justify"
                              dangerouslySetInnerHTML={{
                                __html: team.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Image on Right */}
                      <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db578-4b337b90">
                        <div className="p-1rem">
                          <div className="flex-tag left">
                            <div className="bullet-tag"></div>
                          </div>
                          <div className="">
                            <h2>
                              {team.fname}{" "}
                              <span style={{ color: "#4BBA89" }}>
                                {team.lname}:
                              </span>
                            </h2>
                            <h4
                              dangerouslySetInnerHTML={{
                                __html: team.position,
                              }}
                            ></h4>
                            <p
                              className="subhead mt-5 text-justify"
                              dangerouslySetInnerHTML={{
                                __html: team.description,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                      <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                        <div className="image-wrapper">
                          <img
                            src={team.image}
                            alt={`${team.fname} ${team.lname}`}
                            className="cover-animated-image cover-animated-image1 w-full h-auto rounded-2xl shadow-lg"
                            loading="eager"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </section>
    </>
  );
};

export default MeetTeam;
